import axios from 'axios'

function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_URL
  const configured = typeof raw === 'string' ? raw.trim() : ''

  if (import.meta.env.DEV) {
    return configured || 'http://127.0.0.1:8000'
  }

  if (!configured) {
    return ''
  }

  try {
    const { hostname } = new URL(configured)
    const apiIsLoopback = hostname === 'localhost' || hostname === '127.0.0.1'
    if (apiIsLoopback && typeof window !== 'undefined') {
      const h = window.location.hostname
      const pageIsLoopback = h === 'localhost' || h === '127.0.0.1'
      if (!pageIsLoopback) {
        // Сборка с VITE_API_URL на 127.0.0.1:8100 на реальном домене ломает логин (CSP) и cookies.
        return ''
      }
    }
  } catch {
    return ''
  }

  return configured
}

const API_URL = resolveApiBaseUrl()

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
})

// Request interceptor - добавляем токен из localStorage в заголовки
api.interceptors.request.use(
  (config) => {
    // Пытаемся получить токен из localStorage
    try {
      const token = localStorage.getItem('auth_token')
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      // Игнорируем ошибки при работе с localStorage
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Обрабатываем редиректы 303/307 - перенаправляем вручную вместо автоматического следования
    if (response.status === 303 || response.status === 307) {
      const location = response.headers?.location || response.headers?.Location
      if (location) {
        // Перенаправляем на новую страницу
        window.location.href = location
        // Возвращаем ошибку, чтобы предотвратить дальнейшую обработку ответа
        return Promise.reject(new Error('Redirect handled'))
      }
    }
    return response
  },
  async (error) => {
    // Обрабатываем ошибки с редиректами
    if (error.response?.status === 303 || error.response?.status === 307) {
      const location = error.response?.headers?.location || error.response?.headers?.Location
      if (location) {
        window.location.href = location
        return Promise.reject(new Error('Redirect handled'))
      }
    }
    
    // Обрабатываем 401 Unauthorized
    if (error.response?.status === 401) {
      // Проверяем, есть ли информация о редиректе в ответе (для портала)
      const redirectUrl = error.response?.data?.redirect
      if (redirectUrl) {
        window.location.href = redirectUrl
      } else {
        // Для обычных админских страниц редирект на /login
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export { api }
export default api
